import { render, staticRenderFns } from "./default.vue?vue&type=template&id=4183f2b1&scoped=true&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=4183f2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4183f2b1",
  null
  
)

export default component.exports